module.exports = __webpack_public_path__ + "static/media/titulo-recarga-programada.d8ad0eba.png";